<script lang="ts">
    import type {FormattedText} from "./Types";
    export let entity: FormattedText
</script>
{entity.text}
<!-- DO NOT support entity.entities based formatting -->
